import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { motion } from 'framer-motion';

const GetStarted = () => {
  return (
    <motion.div
      className="w-full bg-[#427cfc] py-20 px-4 text-white text-center"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      viewport={{ once: true, amount: 0.2 }}
    >
      <h2 className="text-3xl md:text-3xl font-medium mb-4">
        Be part of the future of clinical AI 
      </h2>
      <p className="text-md md:text-base mb-8">
        Join our Spring 2025 pilot and shape what's next 
      </p>
      <Link
        smooth
        to="/#pricing"
        className="bg-white text-[#427cfc] cursor-pointer font-medium py-3 px-6 rounded-3xl hover:scale-105 transition duration-300 inline-block"
      >
        Apply Now
      </Link>
    </motion.div>
  );
};

export default GetStarted;